export default function DTD_Elements() {
  return (
    <div>
      <h1>DTD_Elements</h1>
      <p>This is the DTD_Elements component.</p>
    </div>
  );
}